import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Row, Col, Select } from 'antd';
import { TEAM_MEMBER_FIELDS } from '../constants';
import { DEFAULT_SERVER_STATUS, primaryContactOptions } from '../constants';

export default function TeamMemberModal({ visible, onCancel, onSave, initialData, customer }) {
  const [form] = Form.useForm();
  const [serverResponse, setServerResponse] = useState(DEFAULT_SERVER_STATUS);

  useEffect(() => {
    if (visible) {
      setServerResponse(DEFAULT_SERVER_STATUS);
      if (initialData) {
        form.setFieldsValue(initialData);
      } else {
        form.resetFields();
        form.setFieldValue('is_primary', true);
      }
    }
  }, [initialData, form, visible]);

  const onFinish = async values => {
    const response = await onSave({ ...initialData, ...values, customer_id: customer.id });
    const { success, code } = response;
    setServerResponse({success, code, message: response.message});
    if (success && !response?.message) {
      form.resetFields();
    }
  };

  const onEdit = () => {
    setServerResponse(DEFAULT_SERVER_STATUS);
  }

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      title={(initialData && initialData.id) ? `Edit ${customer.name} Team Member` : `Add ${customer.name} Team Member`}
      onOk={() => form.submit()}
    >
      <Form
        form={form}
        name="customer"
        layout="vertical"
        onFinish={onFinish}
        >
        <Row gutter={16}>
            {TEAM_MEMBER_FIELDS.map(field => (
              <Col
                key={field.name}
                xs={24}
                sm={24}
                md={12}
              >
                <Form.Item
                  key={field.name}
                  name={field.name}
                  label={field.label}
                  rules={field.rules}
                >
                  {
                    field.name === 'is_primary' ?
                    <Select
                      placeholder="Is Primary Contact?"
                      onChange={() => onEdit()}
                      style={{ width: '100%'}}
                      optionFilterProp='children'
                    >
                      {primaryContactOptions?.length > 0 && primaryContactOptions.map((c) => (
                        <Select.Option key={c.label} value={c.value}>{c.label}</Select.Option>
                      ))}
                    </Select>
                      : 
                    <Input onChange={() => {onEdit()}} />
                  }
                </Form.Item>
            </Col>
            ))}
        </Row>
        </Form>
        {
          (!serverResponse.status && serverResponse.message) &&
          <div style={{textAlign: 'center'}}>
            <label style={{color: 'red'}}>{serverResponse.message} {serverResponse.code ? `(${serverResponse.code})` : ''}</label>
          </div>
        }
    </Modal>
  );
}
